import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';
import {auth} from './firebaseConfig';
import './styles/global.scss';
import './libraries/fontawesome';

Vue.config.productionTip = false;

import Vue2TouchEvents from 'vue2-touch-events';
import SearchStore from './store/SearchStore';
import LocationsStore from './store/LocationsStore';
Vue.use(Vue2TouchEvents);

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title) ? to.meta.title + ' - Edison ParkFast' : 'Edison ParkFast';

  next();
});

// SearchStore.RestoreSearch();
// LocationsStore.GetLocations();

// handle page reloads
let app: any;
auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }
})